<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Informe De Estados De Póliza
        </v-card-title>
        <v-container fluid grid-list-sm>
            <v-row dense  v-if="!_.get(parametros,'isUserAseguradora',false)">
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete label="Canal *" color="textbox" v-model="obSearch.idCanal"
                        :items="listGeneral.listCanal" item-value="idCanal" item-text="canal"
                        @change="listarAseguradora" outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Aseguradora *" color="textbox" v-model="obSearch.idAseguradora"
                        :items="listGeneral.listAseguradora" item-value="idAseguradora" item-text="aseguradora"
                        @change="onListarSeguro" outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Seguro *" color="textbox" v-model="obSearch.idSeguro"
                        :items="listGeneral.listSeguro" item-text="seguro" item-value="idSeguro" 
                        outlined dense />
                </v-col>
            </v-row>

            <v-row v-else>
                <v-col cols="12" sm="4">
                    <v-text-field label="Aseguradora" color="textbox" :value="_.get(listGeneral,['listAseguradora','0','aseguradora'],'N/A')" outlined dense readonly/>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete label="Canal *" color="textbox" v-model="obSearch.idCanal"
                        :items="listGeneral.listCanal" item-value="idCanal" item-text="canal"
                        @change="onListarSeguro" outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Seguro *" color="textbox" v-model="obSearch.idSeguro"
                        :items="listGeneral.listSeguro" item-text="seguro" item-value="idSeguro" 
                        outlined dense />
                </v-col>
            </v-row>

            <v-row dense>
                <v-col cols="12" sm="3">
                    <v-autocomplete label="Tipo Póliza *" color="textbox" v-model="obSearch.idTipoPoliza"
                        :items="listGeneral.listTipoPoliza" item-text="tipoPoliza" item-value="idTipoPoliza" 
                        outlined dense />
                </v-col>
                <v-col cols="12" sm="3">
                    <v-dialog ref="dialogFechaDesde" v-model="abrirModalDesde"
                        :return-value.sync="obSearch.fechaDesde" persistent width="330px">
                        <template v-slot:activator="{ on }">
                            <v-text-field color="textbox" v-model="obSearch.fechaDesde" label="Fecha Desde*"
                                prepend-inner-icon="event" readonly outlined dense v-on="on" />
                        </template>
                        <v-date-picker color="primary" v-model="obSearch.fechaDesde" scrollable locale="es">
                            <v-spacer></v-spacer>
                            <v-btn outlined dense rounded color="danger" @click="abrirModalDesde = false"
                                v-html="'Salir'"></v-btn>
                            <v-btn rounded dark color="primary"
                                @click="$refs.dialogFechaDesde.save(obSearch.fechaDesde);" v-html="'Guardar Fecha'">
                            </v-btn>
                        </v-date-picker>
                    </v-dialog>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-dialog ref="dialogFechaHasta" v-model="abrirModalHasta"
                        :return-value.sync="obSearch.fechaHasta" persistent width="330px">
                        <template v-slot:activator="{ on }">
                            <v-text-field color="textbox" v-model="obSearch.fechaHasta" label="Fecha Hasta*"
                                prepend-inner-icon="event" readonly outlined dense v-on="on" />
                        </template>
                        <v-date-picker color="primary" v-model="obSearch.fechaHasta" scrollable locale="es">
                            <v-spacer></v-spacer>
                            <v-btn outlined dense rounded color="danger" @click="abrirModalHasta = false"
                                v-html="'Salir'"></v-btn>
                            <v-btn rounded dark color="primary"
                                @click="$refs.dialogFechaHasta.save(obSearch.fechaHasta);" v-html="'Guardar Fecha'">
                            </v-btn>
                        </v-date-picker>
                    </v-dialog>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-autocomplete label="Estado *" color="textbox" v-model="obSearch.idEstado"
                        :items="listGeneral.listEstado" item-text="nombre_estado" item-value="id_estado" outlined
                        dense />
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" sm="6">

                </v-col>
                <v-col cols="12" sm="6" class="text-right">
                    <v-tooltip bottom color="primary">
                        <template v-slot:activator="{ on }">
                            <v-btn outlined color="primary" @click="onListar" v-on="on" :disabled="disabled">
                                Buscar<v-icon>search</v-icon>
                            </v-btn>
                        </template>
                        <span>Buscar</span>
                    </v-tooltip>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col v-if="_.size(listGeneral.listDetalle) == 0" cols="12" sm="12"></v-col>
                <v-col v-else cols="12" sm="12">
                    <v-btn rounded color="primary" dark @click="exportar('table','Informe de Estados de Póliza')">Exportar a XLSX</v-btn>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col cols="12" sm="6">
                    <v-checkbox label="Agrupar por Canal" v-model="group" dense color="primary"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" clearable dense
                        prepend-inner-icon="search" />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <v-data-table :search="obSearch.search" :headers="listGeneral.listCabecera"  :group-by="group ? ['canal']: []"
                        :items="listGeneral.listDetalle" class="elevation-3" id="">

                        <template v-slot:no-results>
                            Tu búsqueda de "<span v-html="obSearch.search"></span>" no arrojó resultados.
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        name: 'InformeEstadosPolizaView',
        data: () => ({
            group:false,
            disabled:false,
            abrirModalDesde:false,
            abrirModalHasta:false,
            obSearch:{
                search:'',
                idAseguradora:null,
                idSeguro:null,
                idTipoPoliza:null,
                idCanal:null,
                fechaDesde:moment().format('YYYY-MM-DD'),
                fechaHasta:moment().format('YYYY-MM-DD'),
                idEstado:null,
            },
            listGeneral:{},
            parametros:{}
        }),
        created(){
            var error = 'E';

            axios.post(`${BASE_URI}administrador/informe-estado-poliza/cargaGeneral`)
                 .then((r)=>{
                     if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                     if(_.size(_.get(r,['data','data'],[])) == 0) { error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion) }
                        this.$set(this,'listGeneral',r.data.data.listas);
                        this.$set(this,'parametros',r.data.data.parametros);
                        this.obSearch.idEstado = _.toString(this.parametros.id_estado_default);

                        this.obSearch.idCanal = this.listGeneral.listCanal[0].idCanal;
                        var l = _.cloneDeep(this.listGeneral.listCanal);
                        if(this.parametros.isUserAseguradora){
                            l = _.filter(l,(v)=>{ return _.toNumber(v.idCanal) != this.parametros.id_tipo_canal_tradicional });
                            this.obSearch.idAseguradora = this.listGeneral.listAseguradora[0].id_aseguradora;
                        }

                        var ll = [];
                        ll.push({idCanal:0,canal:"Todos"});

                        _.forEach(l,(v)=>{
                            ll.push(v);
                        });

                        this.listGeneral.listCanal = ll;

                        if(this.parametros.isUserAseguradora)
                            return this.onListarSeguro('L');
                        else
                            return this.listarAseguradora('L');
                 })
                 .catch((e)=>{
                    mensajesAlerta(e,error);
                 });
        },
        methods:{
            listarAseguradora(event){
                if(!_.isUndefined(event)){
                    var error = 'E';
                    var o = {
                        opcion:'LISTAR_ASEGURADORA_X_CANAL',
                        idCanal: _.toNumber(this.obSearch.idCanal) == 0 ? null : this.obSearch.idCanal,
                        idEstado: this.parametros.id_estado_default
                    }

                    this.$set(this.listGeneral,'listAseguradora',[]);

                    axios.post(`${BASE_URI}administrador/informe-estado-poliza/listar`,o)
                         .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) { error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion) }
                                this.$set(this.listGeneral,'listAseguradora',r.data.data);
                        })
                        .catch((e)=>{
                            mensajesAlerta(e,error);
                        });
                }
            },
            onListarSeguro(event){
                if(!_.isUndefined(event)){
                    var error = 'E';
                    var o = {
                        opcion:'LISTAR_SEGURO_X_ASEGURADORA_CANAL',
                        idCanal: _.toNumber(this.obSearch.idCanal) == 0 ? null : this.obSearch.idCanal,
                        idAseguradora: this.obSearch.idAseguradora,
                        idEstado: this.parametros.id_estado_default
                    }

                    this.$set(this.listGeneral,'listSeguro',[]);

                    axios.post(`${BASE_URI}administrador/informe-estado-poliza/listar`,o)
                         .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) { error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion) }
                                var l = [];
                                l.push({"idSeguro":"0","seguro":"Todos"});
                                _.forEach(r.data.data,(v)=>{
                                    l.push(v);
                                });
                                this.$set(this.listGeneral,'listSeguro',l);
                        })
                        .catch((e)=>{
                            mensajesAlerta(e,error);
                        });
                }
            },
            onListar(event){
                if(!_.isUndefined(event)){
                    this.disabled = true;
                    var error = 'E';
                    var o = {
                        opcion:'LISTAR',
                        idCanal: _.toNumber(this.obSearch.idCanal) == 0 ? null : this.obSearch.idCanal,
                        idAseguradora: this.obSearch.idAseguradora,
                        idSeguro: _.toNumber(this.obSearch.idSeguro) == 0 ? null : this.obSearch.idSeguro,
                        idTipoPoliza: _.toNumber(this.obSearch.idTipoPoliza) == 0 ? null : this.obSearch.idTipoPoliza,
                        fechaDesde: this.obSearch.fechaDesde,
                        fechaHasta: this.obSearch.fechaHasta,
                        idEstado: _.toNumber(this.obSearch.idEstado) == 0 ? null : this.obSearch.idEstado,
                    }

                    this.$set(this.listGeneral,'listDetalle',[]);

                    axios.post(`${BASE_URI}administrador/informe-estado-poliza/listar`,o)
                         .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) { error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion) }
                                this.$set(this.listGeneral,'listDetalle',r.data.data);
                                this.disabled = false;
                        })
                        .catch((e)=>{
                            mensajesAlerta(e,error);
                            this.disabled = false;
                        });
                }
            },
        }
    }
</script>
